// extracted by mini-css-extract-plugin
module.exports = {"minitv":"U5Hsh","minitvInnerContainer":"iiJJz","blinker":"_XsJZ","minitv_txt":"OvJEn"};